



































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import GridDisplay from "@/components/GridDisplay.vue";
import GridSelection from "@/components/GridSelection.vue";
import GridSelectArea from "@/components/GridSelectArea.vue";
import DrawerPlacementSelection from "@/components/DrawerPlacementSelection.vue";
import GridConnection from "@/components/GridConnection.vue";
import PlacementDisplay from "@/components/PlacementDisplay.vue";
import CountTable from "@/components/CountTable.vue";
import Help from "@/components/Help.vue";
import { CellPlacement } from "@/types/CellPlacement";
import {
  generateSelectedCell,
  calcMoveCell,
  isOutOfRange,
  findAreaTopLeft,
  calculateAreaSize
} from "@/utils/cell-calc";
import { isSeed } from "@/utils/placement-util";
import { InferenceArea } from "./types/CellPlacement";
import Layout from "@/layout/harvest-layout.json";
import { getShare, fromShare } from "./utils/link-share";
import Axios from "axios";
import moment from "moment";
const defaultSettings = {
  pylon: {
    alwaysShowLink: true,
    alwaysShowArea: false,
    areaBorderOpacity: 30,
    areaBackgroundOpacity: 10,
    placementOpacity: 60
  },
  collector: {
    alwaysShowArea: true,
    areaBorderOpacity: 30,
    areaBackgroundOpacity: 10,
    placementOpacity: 60
  },
  disperser: {
    alwaysShowArea: false,
    areaBorderOpacity: 30,
    areaBackgroundOpacity: 10,
    placementOpacity: 60
  },
  seedEnhancer: {
    alwaysShowArea: false,
    areaBorderOpacity: 30,
    areaBackgroundOpacity: 10,
    placementOpacity: 60
  },
  seed: {
    tier1Opacity: 20,
    tier2Opacity: 20,
    tier3Opacity: 40,
    tier4Opacity: 60
  },
  storage: {
    placementOpacity: 60
  },
  horticraftingStation: {
    placementOpacity: 60
  },
  linkFilter: null,
  linkOpacity: 70,
  greyscaleTerrain: false
};
export default Vue.extend({
  props: {
    planData: {
      default: ""
    }
  },
  name: "Main",
  components: {
    GridDisplay,
    GridSelection,
    GridSelectArea,
    DrawerPlacementSelection,
    GridConnection,
    PlacementDisplay,
    CountTable,
    Help
  },
  created() {
    const storedLibrary = localStorage.getItem("library");
    if (storedLibrary) {
      this.$set(this, "profileLibrary", JSON.parse(storedLibrary));
    }

    const storedSettings = localStorage.getItem("settings");
    if (storedSettings) {
      this.$set(this, "settings", {
        ...defaultSettings,
        ...JSON.parse(storedSettings)
      });
    }
    document.addEventListener("keydown", this.moveListener);
    document.addEventListener("keyup", this.keyboardListener);
    if (+(localStorage.getItem("version") ?? 0) < 2) {
      localStorage.setItem("version", "2");
      this.showHelpDialog = true;
    }
    if (!this.planData) {
      this.$set(this, "cellPlacement", JSON.parse(localStorage.getItem("storedSetup") ?? "[]"));
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.moveListener);
    document.removeEventListener("keyup", this.keyboardListener);
  },
  data() {
    return {
      placementClipboard: [] as (CellPlacement | null)[][],
      shareLoading: false,
      linkFilterOptions: [
        {
          label: "Wild",
          value: 0
        },
        {
          label: "Vivid",
          value: 1
        },
        {
          label: "Primal",
          value: 2
        }
      ],
      row: 42,
      col: 42,
      moveInterval: [null, null, null, null],
      layoutText: "",
      planLink: "",
      connectionFailSnackbar: false,
      connectionFailType: 0,
      failSnackbar: false,
      linkCopiedSnackbar: false,
      routerSetting: false,
      profileName: "",
      namingMode: 0,
      renameItem: 0,
      confirmMode: 0,
      confirmItem: 0,
      showConfirmDialog: false,
      showNamingDialog: false,
      showLibraryDialog: false,
      showImportDialog: false,
      showHelpDialog: false,
      showShareDialog: false,
      showSettingDialog: false,
      objectName: {
        P: "Pylon",
        C: "Collector",
        S: "Storage",
        D: "Disperser",
        "1": "Tier 1 Seed",
        "2": "Tier 2 Seed",
        "3": "Tier 3 Seed",
        "4": "Tier 4 Seed",
        H: "Horticrafting Station",
        "E1,3": "Fortune Bud",
        "E1,4": "Lifeforce Bud",
        "E1,5": "Horticrafting Bud",
        "E2,3": "Fortune Flower",
        "E2,4": "Lifeforce Flower",
        "E2,5": "Horticrafting Flower",
        "E3,3": "Fortune Blossom",
        "E3,4": "Lifeforce Blossom",
        "E3,5": "Horticrafting Blossom"
      } as Record<string, string>,
      color: ["purple--text", "yellow--text", "blue--text"],
      btnColor: ["purple", "yellow", "blue"],
      selectingArea: [] as number[][],
      connectingPoints: [] as number[][],
      linkHovering: [] as number[],
      selection: [] as number[][],
      connection: [] as number[][],
      cellPlacement: [] as CellPlacement[],
      hoveringCell: [] as number[],
      lastStep: [] as string[],
      nextStep: [] as string[],
      settings: { ...defaultSettings },
      isUndo: false,
      isRedo: false,
      seed: ["1", "2", "3", "4"],
      profileLibrary: [] as Record<string, string>[],
      isCtrlConnect: false
    };
  },
  methods: {
    pastePlacement() {
      const topLeft = findAreaTopLeft(this.selection);
      for (let i = 0; i < this.placementClipboard.length; i++) {
        for (let j = 0; j < this.placementClipboard[i].length; j++) {
          const placementToPaste = this.placementClipboard[i][j];
          if (placementToPaste) {
            this.addPlacement({ ...placementToPaste, x: topLeft[0] + i, y: topLeft[1] + j });
          } else {
            this.removePlacement(topLeft[0] + i, topLeft[1] + j);
          }
        }
      }
    },
    copyAreaPlacement() {
      const topLeft = findAreaTopLeft(this.selection);
      const selectedSize = calculateAreaSize(this.selection);
      const placementMatrix: (CellPlacement | null)[][] = [];
      for (let i = 0; i < selectedSize[0]; i++) {
        placementMatrix[i] = [];
        for (let j = 0; j < selectedSize[1]; j++) {
          placementMatrix[i][j] = this.findPlacement(topLeft[0] + i, topLeft[1] + j);
        }
      }
      this.$set(this, "placementClipboard", placementMatrix);
    },
    resetSetting() {
      this.settings = { ...defaultSettings };
    },
    confirmProfile() {
      if (this.confirmMode == 0) {
        this.replaceProfile();
      } else if (this.confirmMode == 1) {
        this.deleteProfile();
      }
      this.showConfirmDialog = false;
    },
    deleteProfile() {
      this.profileLibrary.splice(this.confirmItem, 1);
    },
    replaceProfile() {
      this.profileLibrary[this.confirmItem].time = moment().format("YYYY-MM-DD HH:mm");
      this.profileLibrary[this.confirmItem].content = getShare(this.cellPlacement);
    },
    showDeleteConfirm(index: number) {
      this.confirmItem = index;
      this.confirmMode = 1;
      this.showConfirmDialog = true;
    },
    showReplaceConfirm(index: number) {
      this.confirmItem = index;
      this.confirmMode = 0;
      this.showConfirmDialog = true;
    },
    loadSetup(placement: string) {
      this.$router.replace(`/${placement}`);
      this.showLibraryDialog = false;
    },
    saveProfile() {
      if (this.namingMode == 0) {
        if (this.profileLibrary[this.renameItem]) {
          this.profileLibrary[this.renameItem].name = this.profileName;
        }
      } else if (this.namingMode == 1) {
        this.profileLibrary.push({
          name: this.profileName,
          time: moment().format("YYYY-MM-DD HH:mm"),
          content: getShare(this.cellPlacement)
        });
      }
      this.showNamingDialog = false;
    },
    openRenameProfileDialog(index: number) {
      this.namingMode = 0;
      this.renameItem = index;
      this.profileName = this.profileLibrary[index]?.name ?? "";
      this.showNamingDialog = true;
    },
    openCreateProfileDialog() {
      this.namingMode = 1;
      this.profileName = "";
      this.showNamingDialog = true;
    },
    importLayout() {
      this.$set(this, "cellPlacement", JSON.parse(this.layoutText));
      this.layoutText = "";
      this.showImportDialog = false;
    },
    async undo() {
      if (this.lastStep.length <= 0) {
        return;
      }
      this.nextStep.push(JSON.stringify(this.cellPlacement));
      this.isUndo = true;
      await this.$nextTick();
      const lastStep = this.lastStep.pop() || "[]";
      this.$set(this, "cellPlacement", JSON.parse(lastStep));
      await this.$nextTick();
      this.isUndo = false;
    },
    async redo() {
      if (this.nextStep.length <= 0) {
        return;
      }
      this.isRedo = true;
      await this.$nextTick();
      this.$set(this, "cellPlacement", JSON.parse(this.nextStep.pop() || "[]"));
      await this.$nextTick();
      this.isRedo = false;
    },
    copyLink() {
      ((this.$refs.linkTextField as Vue).$refs.input as HTMLInputElement).select();
      document.execCommand("copy");
      this.linkCopiedSnackbar = true;
    },
    async sharePlan() {
      this.shareLoading = true;
      await this.sharePlanOrProfile(getShare(this.cellPlacement));
      this.shareLoading = false;
    },
    async sharePlanOrProfile(profile: string) {
      try {
        const result = await Axios.post("https://iw.gy/shorten", {
          url: `${window.location.origin}/#/${profile}`
        });
        this.planLink = result.data.shortenedLink;
        this.showShareDialog = true;
      } catch {
        this.failSnackbar = true;
      }
    },
    isSelected() {
      return (
        this.selection[0] &&
        this.selection[1] &&
        this.selection[0][0] >= 0 &&
        this.selection[1][0] >= 0 &&
        this.selection[0][1] >= 0 &&
        this.selection[1][1] >= 0
      );
    },
    isSingleSelection() {
      return (
        this.selection[0] &&
        this.selection[1] &&
        this.selection[0][0] == this.selection[1][0] &&
        this.selection[0][1] == this.selection[1][1]
      );
    },
    moveListener(e: KeyboardEvent) {
      if (e.keyCode == 67 && e.ctrlKey) {
        this.copyAreaPlacement();
        return;
      }

      if (e.keyCode == 88 && e.ctrlKey) {
        this.copyAreaPlacement();
        this.clearPlacement();
        return;
      }

      if (e.keyCode == 86 && e.ctrlKey) {
        this.pastePlacement();
        return;
      }

      if (e.keyCode == 17 && this.isSingleSelection() && !this.isCtrlConnect) {
        this.isCtrlConnect = true;
        this.connectingPoints = [this.selection[0], this.selection[0]];
        return;
      }

      let moveCell: number = e.shiftKey ? 5 : 1;
      if (this.isSelected()) {
        if (this.isCtrlConnect) {
          this.$set(this.connectingPoints, 1, [this.connectingPoints[1][0], this.connectingPoints[1][1]]);
          const point = this.connectingPoints[1];
          if (e.keyCode == 37) {
            moveCell = -moveCell;
            this.$set(this.connectingPoints[1], 1, calcMoveCell(point[1], point[1], moveCell, this.row)[0]);
          }
          if (e.keyCode == 38) {
            moveCell = -moveCell;
            this.$set(this.connectingPoints[1], 0, calcMoveCell(point[0], point[0], moveCell, this.row)[0]);
          }
          if (e.keyCode == 39) {
            this.$set(this.connectingPoints[1], 1, calcMoveCell(point[1], point[1], moveCell, this.row)[0]);
          }
          if (e.keyCode == 40) {
            this.$set(this.connectingPoints[1], 0, calcMoveCell(point[0], point[0], moveCell, this.row)[0]);
          }
        } else {
          let [x0, x1, y0, y1] = [
            this.selectingArea[0][0],
            this.selectingArea[1][0],
            this.selectingArea[0][1],
            this.selectingArea[1][1]
          ];
          if (e.keyCode == 37) {
            moveCell = -moveCell;
            [y0, y1] = calcMoveCell(y0, y1, moveCell, this.row);
            this.$set(this.selectingArea[0], 1, y1);
            this.$set(this.selectingArea[1], 1, y0);
          }
          if (e.keyCode == 38) {
            moveCell = -moveCell;
            [x0, x1] = calcMoveCell(x0, x1, moveCell, this.col);
            this.$set(this.selectingArea[0], 0, x1);
            this.$set(this.selectingArea[1], 0, x0);
          }
          if (e.keyCode == 39) {
            [y0, y1] = calcMoveCell(y0, y1, moveCell, this.row);
            this.$set(this.selectingArea[1], 1, y0);
            this.$set(this.selectingArea[0], 1, y1);
          }
          if (e.keyCode == 40) {
            [x0, x1] = calcMoveCell(x0, x1, moveCell, this.col);
            this.$set(this.selectingArea[1], 0, x0);
            this.$set(this.selectingArea[0], 0, x1);
          }
        }
      }
    },
    keyboardListener(e: KeyboardEvent) {
      if (e.keyCode == 17 && this.isCtrlConnect) {
        this.isCtrlConnect = false;
        this.connection = this.connectingPoints;
        return;
      }

      if (e.keyCode == 90 && e.ctrlKey) {
        this.undo();
        return;
      }
      if (e.keyCode == 46) {
        this.clearPlacement();
        return;
      }
      if (e.keyCode == 27) {
        this.selection = [];
        this.selectingArea = [];
        return;
      }
    },
    setPlacementColor(color: number) {
      generateSelectedCell(this.selection).forEach(i => {
        const placement = this.findPlacement(i[0], i[1]);
        if (placement) {
          placement.color = color;
        }
      });
    },
    clearPlacement() {
      generateSelectedCell(this.selection).forEach(i => {
        this.removePlacement(i[0], i[1]);
      });
    },
    clearAllPlacement() {
      this.$set(this, "cellPlacement", []);
    },
    getLinkedPlacementPos(current: number[], connection: number[][]) {
      const [cx, cy] = connection;
      if (current[0] == cx[0] && current[1] == cy[0]) {
        return [cx[1], cy[1]];
      }
      return [cx[0], cy[0]];
    },
    hoverLinkItem(c: number[] | null) {
      this.linkHovering = c || [];
    },
    setSelection(i: number, j: number) {
      this.$set(this, "selectingArea", [
        [i, j],
        [i, j]
      ]);
      this.$set(this, "selection", [
        [i, j],
        [i, j]
      ]);
    },
    getPlacementProp(i: number, j: number) {
      const placementObj = this.findPlacement(i, j);
      const placement = placementObj?.text;
      const placementColor = placementObj?.color;
      console.log(placement, placementColor);
      return {
        name: placement
          ? this.objectName[placement.startsWith("E") ? `${placement},${placementColor}` : placement]
          : "",
        color: this.color[placementColor ?? -1]
      };
    },
    placeItem(args: ("P" | "C" | "S" | "D" | "1" | "2" | "3" | "4" | "H" | number)[]) {
      if (typeof args[0] != "number" && typeof args[1] == "number") {
        this.setPlacement(this.selection, args[0], args[1]);
      }
    },
    checkHoverable(i: number, j: number) {
      return Layout[i - 1][j - 1] == 0;
    },
    setPlacement(selectedArea: number[][], type: "P" | "C" | "S" | "D" | "1" | "2" | "3" | "4" | "H", color?: number) {
      if (!this.isSelected()) {
        return;
      }
      generateSelectedCell(selectedArea).forEach(i => {
        this.addPlacement({
          x: i[0],
          y: i[1],
          text: type,
          color
        });
      });
    },
    removePlacement(i: number, j: number) {
      const index = this.cellPlacement.findIndex(o => o.x == i && o.y == j);
      if (index >= 0) {
        this.cellPlacement.splice(index, 1);
      }
      this.cellPlacement
        .filter(
          c =>
            c.text == "connection" &&
            (((c.x as number[])[0] == i && (c.y as number[])[0] == j) ||
              ((c.x as number[])[1] == i && (c.y as number[])[1] == j))
        )
        .forEach(c => this.removeConnection(c));
      this.hoverLinkItem(null);
    },
    addPlacement(placement: CellPlacement) {
      if (typeof placement.x === "number" && typeof placement.y === "number") {
        if (!this.checkHoverable(+placement.x, +placement.y)) {
          return;
        }
        if (placement.x > this.row || placement.x < 1) {
          return;
        }

        if (placement.y > this.col || placement.y < 1) {
          return;
        }
      }
      const index = this.cellPlacement.findIndex(i => i.x == placement.x && i.y == placement.y);
      if (index >= 0) {
        this.removePlacement(+placement.x, +placement.y);
      }
      this.cellPlacement.push(placement);
    },
    findPlacement(i: number, j: number): CellPlacement | null {
      return this.cellPlacement.find(o => o.x == i && o.y == j) ?? null;
    },
    findPlacementFromConnection(connection: CellPlacement) {
      if (
        !connection ||
        connection.text != "connection" ||
        typeof connection.x == "number" ||
        typeof connection.y == "number"
      ) {
        return [];
      }
      return [
        this.findPlacement(connection.x[0], connection.y[0]) ?? null,
        this.findPlacement(connection.x[1], connection.y[1]) ?? null
      ];
    },
    findPylonConnection(pylon: CellPlacement) {
      if (!pylon) return [];
      return this.cellPlacement.filter(
        p =>
          p.text == "connection" &&
          typeof p.x != "number" &&
          typeof p.y != "number" &&
          ((pylon.x == p.x[0] && pylon.y == p.y[0]) || (pylon.x == p.x[1] && pylon.y == p.y[1]))
      );
    },
    findConnection(p1: CellPlacement, p2: CellPlacement) {
      let [x1, x2, y1, y2] = [+p1.x, +p2.x, +p1.y, +p2.y];
      if (x1 > x2) {
        [x1, x2] = [x2, x1];
        [y1, y2] = [y2, y1];
      }
      return this.cellPlacement.find(
        p =>
          p.text == "connection" &&
          typeof p.x != "number" &&
          typeof p.y != "number" &&
          x1 == p.x[0] &&
          x2 == p.x[1] &&
          y1 == p.y[0] &&
          y2 == p.y[1]
      );
    },
    addConnection(p1: CellPlacement, p2: CellPlacement) {
      if (isSeed(p1) || isSeed(p2)) {
        this.connectionFailType = 0;
        this.connectionFailSnackbar = true;
        return;
      }

      if (p1.text != "P" && p2.text != "P") {
        this.connectionFailType = 3;
        this.connectionFailSnackbar = true;
        return;
      }

      if (
        (p1.text == "P" && this.findPylonConnection(p1).length >= 4) ||
        (p2.text == "P" && this.findPylonConnection(p2).length >= 4)
      ) {
        this.connectionFailType = 2;
        this.connectionFailSnackbar = true;
        return;
      }

      if (isOutOfRange([+p1.x, +p1.y], [+p2.x, +p2.y], 4)) {
        this.connectionFailType = 1;
        this.connectionFailSnackbar = true;
        return;
      }

      if (this.findConnection(p1, p2)) {
        return;
      }

      if (p1 == p2) {
        return;
      }

      const [x1, x2, y1, y2] = [+p1.x, +p2.x, +p1.y, +p2.y];
      this.cellPlacement.push({
        color: p1.color,
        text: "connection",
        x: x1 > x2 ? [x2, x1] : [x1, x2],
        y: x1 > x2 ? [y2, y1] : [y1, y2]
      });
    },
    rightClickConnect(point: number[]) {
      const p1 = this.findPlacement(point[0], point[1]);
      const p2 = this.findPlacement(this.connectingPoints[0][0], this.connectingPoints[0][1]);
      if (!(p1 && p2)) {
        return;
      }
      this.addConnection(p1, p2);
    },
    setConnection() {
      const p1 = this.findPlacement(this.connection[0][0], this.connection[0][1]);
      const p2 = this.findPlacement(this.connection[1][0], this.connection[1][1]);
      if (!(p1 && p2)) {
        return;
      }
      this.addConnection(p1, p2);
    },
    removeConnection(c: CellPlacement) {
      this.cellPlacement.splice(this.cellPlacement.indexOf(c), 1);
      this.hoverLinkItem(null);
    },
    convertPlacementToInference(placement: CellPlacement | null | undefined): InferenceArea | null {
      if (!placement) {
        return null;
      }
      if (placement.text == "P") {
        return {
          topLeft: [+placement.x - 4, +placement.y - 4],
          size: 8,
          color: placement.color,
          borderOpacity: this.settings.pylon.areaBorderOpacity / 100,
          backgroundOpacity: this.settings.pylon.areaBackgroundOpacity / 100
        };
      }
      if (placement.text == "D") {
        return {
          topLeft: [+placement.x - 2, +placement.y - 2],
          size: 4,
          color: placement.color,
          borderOpacity: this.settings.disperser.areaBorderOpacity / 100,
          backgroundOpacity: this.settings.disperser.areaBackgroundOpacity / 100
        };
      }
      if (placement.text == "C") {
        return {
          topLeft: [+placement.x - 2, +placement.y - 2],
          size: 4,
          color: placement.color,
          borderOpacity: this.settings.collector.areaBorderOpacity / 100,
          backgroundOpacity: this.settings.collector.areaBackgroundOpacity / 100
        };
      }

      if (placement.text == "E1" || placement.text == "E2" || placement.text == "E3") {
        return {
          topLeft: [+placement.x - 5, +placement.y - 5],
          size: 10,
          color: placement.color,
          borderOpacity: this.settings.collector.areaBorderOpacity / 100,
          backgroundOpacity: this.settings.collector.areaBackgroundOpacity / 100
        };
      }
      return null;
    },
    splitOverviewColor(placement: CellPlacement[]) {
      return {
        wild: placement.filter(c => c.color == 0).length,
        vivid: placement.filter(c => c.color == 1).length,
        primal: placement.filter(c => c.color == 2).length,
        total: placement.length
      };
    }
  },
  computed: {
    placementOpacity(): Record<string, number> {
      return {
        P: this.settings.pylon.placementOpacity / 100,
        C: this.settings.collector.placementOpacity / 100,
        D: this.settings.disperser.placementOpacity / 100,
        S: this.settings.storage.placementOpacity / 100,
        H: this.settings.horticraftingStation.placementOpacity / 100,
        "1": this.settings.seed.tier1Opacity / 100,
        "2": this.settings.seed.tier2Opacity / 100,
        "3": this.settings.seed.tier3Opacity / 100,
        "4": this.settings.seed.tier4Opacity / 100,
        E1: this.settings.seedEnhancer.placementOpacity / 100,
        E2: this.settings.seedEnhancer.placementOpacity / 100,
        E3: this.settings.seedEnhancer.placementOpacity / 100
      };
    },
    connectingPlacements(): (CellPlacement | null)[] {
      return [
        this.connectingPoints[0] ? this.findPlacement(this.connectingPoints[0][0], this.connectingPoints[0][1]) : null,
        this.connectingPoints[1] ? this.findPlacement(this.connectingPoints[1][0], this.connectingPoints[1][1]) : null
      ];
    },
    disableShortcut(): boolean {
      return this.showNamingDialog || this.showShareDialog;
    },
    placementOverview(): Record<string, Record<string, number>> {
      const pylon = this.cellPlacement.filter(c => c.text === "P");
      const storage = this.cellPlacement.filter(c => c.text === "S");
      const disperser = this.cellPlacement.filter(c => c.text === "D");
      const collector = this.cellPlacement.filter(c => c.text === "C");
      const horticraftingStation = this.cellPlacement.filter(c => c.text === "H");
      return {
        pylon: this.splitOverviewColor(pylon),
        storage: this.splitOverviewColor(storage),
        disperser: this.splitOverviewColor(disperser),
        collector: this.splitOverviewColor(collector),
        horticraftingStation: this.splitOverviewColor(horticraftingStation)
      };
    },
    selectedOrHoveringConnection() {
      let placement: CellPlacement[] = [];
      if (this.isSingleSelection()) {
        const selectPlacement = this.findPlacement(this.selection[0][0], this.selection[0][1]);
        if (selectPlacement) {
          placement.push(...this.findPylonConnection(selectPlacement));
        }
      }

      const hoverPlacement = this.findPlacement(this.hoveringCell[0], this.hoveringCell[1]);

      if (hoverPlacement) {
        placement.push(...this.findPylonConnection(hoverPlacement));
      }

      placement = placement.filter((f, i) => placement.indexOf(f) == i);
      return placement;
    },
    selectedOrHoveringPlacement() {
      let placement: CellPlacement[] = [];
      if (this.isSingleSelection()) {
        const selectPlacement = this.findPlacement(this.selection[0][0], this.selection[0][1]);
        if (selectPlacement) {
          placement.push(selectPlacement);
          this.findPylonConnection(selectPlacement).forEach(con => {
            this.findPlacementFromConnection(con).forEach(e => {
              if (e) {
                placement.push(e);
              }
            });
          });
        }
      }

      const hoverPlacement = this.findPlacement(this.hoveringCell[0], this.hoveringCell[1]);
      if (hoverPlacement) {
        placement.push(hoverPlacement);

        this.findPylonConnection(hoverPlacement).forEach(con => {
          this.findPlacementFromConnection(con).forEach(e => {
            if (e) {
              placement.push(e);
            }
          });
        });
      }

      placement = placement.filter((f, i) => placement.indexOf(f) == i);
      return placement;
    },
    isConnecting(): boolean {
      return !!this.connectingPoints[0];
    },
    stringifyCellPlacement(): string {
      return JSON.stringify(this.cellPlacement);
    },
    selectedPlacement(): CellPlacement[] {
      if (!(this.selection[0] && this.selection[1])) {
        return [];
      }
      return (generateSelectedCell(this.selection)
        .map(c => this.findPlacement(c[0], c[1]))
        .filter(c => !!c) as CellPlacement[]).filter(c => !!c && c.text != "connection");
    },
    inferenceAreas() {
      const inference: InferenceArea[] = [];

      const placementHover = this.convertPlacementToInference(
        this.findPlacement(this.hoveringCell[0], this.hoveringCell[1])
      );
      if (placementHover) {
        inference.push(placementHover);
      }

      const placementSelection = this.convertPlacementToInference(
        this.findPlacement(this.selection[0]?.[0], this.selection[0]?.[1])
      );
      if (placementSelection) {
        inference.push(placementSelection);
      }

      if (this.settings.pylon.alwaysShowArea) {
        inference.push(
          ...(this.cellPlacement
            .filter(p => p.text == "P")
            .map(p => this.convertPlacementToInference(p))
            .filter(p => p != null) as InferenceArea[])
        );
      }
      if (this.settings.collector.alwaysShowArea) {
        inference.push(
          ...(this.cellPlacement
            .filter(p => p.text == "C")
            .map(p => this.convertPlacementToInference(p))
            .filter(p => p != null) as InferenceArea[])
        );
      }
      if (this.settings.disperser.alwaysShowArea) {
        inference.push(
          ...(this.cellPlacement
            .filter(p => p.text == "D")
            .map(p => this.convertPlacementToInference(p))
            .filter(p => p != null) as InferenceArea[])
        );
      }

      if (this.settings.seedEnhancer.alwaysShowArea) {
        inference.push(
          ...(this.cellPlacement
            .filter(p => p.text == "E1" || p.text == "E2" || p.text == "E3")
            .map(p => this.convertPlacementToInference(p))
            .filter(p => p != null) as InferenceArea[])
        );
      }
      return inference;
    },
    pylonConnections(): CellPlacement[] {
      let connections: CellPlacement[] = [];
      if (this.isConnecting) {
        const connectingPlacement = this.findPlacement(this.connectingPoints[0][0], this.connectingPoints[0][1]);
        if (connectingPlacement) {
          connections.push(...this.findPylonConnection(connectingPlacement));
        }
      } else if (this.settings.pylon.alwaysShowLink) {
        if (typeof this.settings.linkFilter === "number") {
          connections = this.cellPlacement
            .filter(p => p.text == "connection")
            .filter(p => p.color == this.settings.linkFilter);
        } else {
          connections = this.cellPlacement.filter(p => p.text == "connection");
        }
      }
      const placementHover = this.findPlacement(this.hoveringCell[0], this.hoveringCell[1]);
      const placementSelection = this.findPlacement(this.selection[0]?.[0], this.selection[0]?.[1]);
      if (placementHover) {
        connections.push(...this.findPylonConnection(placementHover));
      }
      if (placementSelection) {
        connections.push(...this.findPylonConnection(placementSelection));
      }
      return connections;
    },
    cellPlacementDisplay(): CellPlacement[] {
      return this.cellPlacement.filter(p => p.text != "connection");
    }
  },
  watch: {
    profileLibrary: {
      deep: true,
      handler(val) {
        localStorage.setItem("library", JSON.stringify(val));
      }
    },
    settings: {
      deep: true,
      handler(val) {
        localStorage.setItem("settings", JSON.stringify(val));
      }
    },
    stringifyCellPlacement(val, old) {
      if (this.routerSetting) {
        return;
      }
      if (!this.isUndo) {
        this.lastStep.push(old);
      }
      if (!this.isUndo && !this.isRedo) {
        this.$set(this, "nextStep", []);
      }
    },
    planData: {
      immediate: true,
      async handler(val) {
        if (val && !this.routerSetting) {
          this.$set(this, "nextStep", []);
          this.$set(this, "lastStep", []);
          this.routerSetting = true;
          await this.$nextTick();
          this.$set(this, "cellPlacement", fromShare(val));
          await this.$nextTick();
          this.routerSetting = false;
        }
      }
    },
    async cellPlacement(val) {
      if (this.routerSetting) {
        return;
      }
      this.routerSetting = true;
      await this.$nextTick();
      this.$router.replace(`/${getShare(val)}`);
      localStorage.setItem("storedSetup", JSON.stringify(val));
      await this.$nextTick();
      this.routerSetting = false;
    },
    async connection() {
      this.$set(this, "connectingPoints", []);
      await this.$nextTick();
      this.setConnection();
    }
  }
});
